import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const CallTaskDisplaySkeleton = () => {
  return (
    <div className="CallTaskDisplay">
      <div className="CallTaskDisplay__Table">
        <div className="CallTaskDisplay__Table-body">
          {[...new Array(9)].map((_, i) => (
            <div
              key={i}
              className="CallTaskDisplay__Table-row CallTaskDisplay__Table-row--skeleton"
            >
              {[96, 242, 153, 90, 164, 208, 108].map(width => (
                <Skeleton
                  key={width}
                  className="CallTaskDisplay__Table-row-skeleton-item"
                  width={width}
                  height={14}
                  baseColor="#F6F7F9"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
